module.exports = __webpack_public_path__ + "static/organizations.526d03f1.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/organizations.jpg
// module id = 549
// module chunks = 0